//////// GHG 1.4
const oneFourSchema = {
  title: "1.4 Direct Emissions from Fugitive Sources",
  addAPI: "cat1_4AddEmissionActivityAPI",
  cat: "cat1_4",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "equipmentCategoryId",
      level: 1,
      type: "select",
      label: "Equipment Category",
      optionsAPI: "fugitiveEmisionsEquipmentCategoryAPI",
      required: true,
    },
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Equipment Name",
      optionsAPI: "fugitiveEmissionActivityAPI",
      optionsParamFrom: {
        level: 1,
        key: "equipmentCategoryId",
      },
      required: true,
      autoFillNum: 0,
    },
    ////////石化燃料
    {
      key: "isFossil",
      level: 1,
      type: "select",
      label: "Fossil-origin Methane Release",
      optionsAPI: "cat1_4Fossil",
      required: true,
    },
    {
      key: "refrigerantCalculationId",
      level: 1,
      type: "select",
      label: "Calculation Method",
      optionsAPI: "fugitiveCalculationMethodAPI",
      resetOnChange: true,
      required: true,
    },
    ////////化糞池 ( 員工人數 )跳出
    {
      key: "workingDays",
      level: 2,
      type: "input",
      label: "Working Days ( Year )",
      showIf: {
        all: [
          { level: 1, key: "activityId", notEmpty: true },
          { level: 1, key: "activityId", eq: 14024 },
        ],
      },
      placeholder: 0,
      required: true,
    },
    ////////Calculation Method 選擇會跳出
    {
      key: "value",
      level: 3,
      type: "input",
      label: "% by mass",
      showIf: {
        all: [{ level: 1, key: "refrigerantCalculationId", eq: "3" }],
      },
      cascadeClear: true,
      percentage: true,
      placeholder: "100",
    },
    //////// 選擇其他冷媒設備會跳出
    {
      key: "customFugitiveEmissionRate",
      level: 4,
      type: "input",
      label: "Fugitive Emission Rate",
      showIf: {
        all: [
          { level: 1, key: "refrigerantCalculationId", eq: 2 },
          { level: 1, key: "equipmentCategoryId", eq: 4 },
        ],
        any: [
          {
            level: 1,
            key: "activityId",
            eq: 14029,
          },
          {
            level: 1,
            key: "activityId",
            eq: 14030,
          },
          {
            level: 1,
            key: "activityId",
            eq: 14031,
          },
          {
            level: 1,
            key: "activityId",
            eq: 14032,
          },
        ],
      },
      percentage: true,
      percentageRange: {
        min: 0,
        max: 100,
        helperText: "Enter a value between 0 and 100",
      },
      placeholder: "100",
    },
    ////////顯示逸散率 同時避免清空
    {
      key: "fugitiveEmissions",
      level: 11,
      type: "fugitiveEmissionRate",
      label: "Fugitive Emission Rate(%)",
      showIf: {
        all: [
          { level: 1, key: "refrigerantCalculationId", eq: "2" },
          { level: 1, key: "activityId", notEmpty: true },
          {
            level: 1,
            key: "activityId",
            ne: 14029,
          },
          {
            level: 1,
            key: "activityId",
            ne: 14030,
          },
          {
            level: 1,
            key: "activityId",
            ne: 14031,
          },
          {
            level: 1,
            key: "activityId",
            ne: 14032,
          },
        ],
      },
      constant: true,
    },
  ],
};

export default oneFourSchema;
